
import React, { useEffect, useMemo, useState } from "react";
import { Button, DatePicker, Drawer, Table, Tag, notification } from "antd";
import { adminGetAllSessions, fmtHMS, summarizeByDay } from "../../../../service/trainerTime";
// import {
//   adminGetAllSessions,
//   summarizeByDay,
//   fmtHMS,
// } from "../../../service/trainerTime";

const { RangePicker } = DatePicker;

export default function AdminTimesheet() {
  const [loading, setLoading] = useState(false);
  const [range, setRange] = useState(() => {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
    return [start.getTime(), now.getTime()];
  });
  const [sessions, setSessions] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedTrainer, setSelectedTrainer] = useState(null);

  const fetchAll = async () => {
    setLoading(true);
    try {
      const list = await adminGetAllSessions({ fromMs: range[0], toMs: range[1] });
      setSessions(list);
    } catch (e) {
      console.error(e);
      notification.error({ message: "Failed to load sessions (index may be required in Firestore)" });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [range[0], range[1]]);

  const trainers = useMemo(() => {
    const map = new Map();
    sessions.forEach((s) => {
      if (!map.has(s.trainerId)) map.set(s.trainerId, []);
      map.get(s.trainerId).push(s);
    });
    return Array.from(map.entries()).map(([trainerId, rows]) => ({ trainerId, rows }));
  }, [sessions]);

  const tableData = useMemo(() => {
    return trainers.map(({ trainerId, rows }) => {
      // Sum total by day, then overall total
      const daily = summarizeByDay(rows);
      const totalMs = daily.reduce((acc, d) => acc + d.totalMs, 0);
      return { key: trainerId, trainerId, total: fmtHMS(totalMs), count: rows.length };
    });
  }, [trainers]);

  const columns = [
    { title: "Trainer ID", dataIndex: "trainerId" },
    { title: "Sessions", dataIndex: "count" },
    { title: "Total Time", dataIndex: "total" },
    {
      title: "Actions",
      render: (_, r) => (
        <Button
          onClick={() => {
            setSelectedTrainer(r.trainerId);
            setOpen(true);
          }}
        >
          View Details
        </Button>
      ),
    },
  ];

  const detailRows = useMemo(() => {
    if (!selectedTrainer) return [];
    const rows = sessions.filter((s) => s.trainerId === selectedTrainer);
    return summarizeByDay(rows);
  }, [selectedTrainer, sessions]);

  return (
    <div className="p-4 text-white">
      <div className="mb-4 flex items-center justify-between">
        <div className="text-lg font-semibold">Admin · Trainer Timesheets</div>
        <RangePicker showTime onChange={(v) => v && setRange([v[0].toDate().getTime(), v[1].toDate().getTime()])} />
      </div>

      <Table
        rowKey="key"
        loading={loading}
        columns={columns}
        dataSource={tableData}
        pagination={{ pageSize: 10 }}
      />

      <Drawer
        title={`Trainer: ${selectedTrainer || ""}`}
        placement="right"
        width={520}
        onClose={() => setOpen(false)}
        open={open}
      >
        {detailRows.map((day) => (
          <div key={day.date} className="mb-4">
            <div className="mb-1 text-sm text-gray-300">{day.date} · Total {fmtHMS(day.totalMs)}</div>
            <Table
              size="small"
              rowKey={(r) => r.id}
              columns={[
                { title: "Start", dataIndex: "startedAtMs", render: (ms) => new Date(ms).toLocaleString() },
                { title: "End", dataIndex: "endedAtMs", render: (ms, r) => (r.status === "active" ? <Tag color="gold">Active</Tag> : new Date(ms).toLocaleString()) },
                { title: "Duration", dataIndex: "durationMs", render: (ms, r) => (r.status === "active" ? "—" : fmtHMS(ms || 0)) },
                { title: "Source", dataIndex: "source", render: (s) => <Tag>{s || "manual"}</Tag> },
              ]}
              dataSource={day.sessions}
              pagination={false}
            />
          </div>
        ))}
      </Drawer>
    </div>
  );
}
